import { z } from 'src/lib';
import { OperacionLEPEmisorFields, OperacionLEPFields, OperacionLEPTituloFields, OperacionLEPUnidadNegocioFields } from './fields';
import { EntityWithIdFields, schemaEntityWithId, schemaEntityWithIdAndDescription } from "../../../../../types";

export const schemaOperacionLEPEmisorInsert = z.object({
    [OperacionLEPEmisorFields.RazonSocial]: z.string().min(1, 'La razón social es requerida'),
    [OperacionLEPEmisorFields.CodOperacionLEPEmisorTipo]: z.number().min(1, 'El tipo de emisor es requerido')
});

export const schemaOperacionLEPEmisorUpdate = z.object({
    [EntityWithIdFields.Id]: z.number(),
    [OperacionLEPEmisorFields.RazonSocial]: z.string().min(1, 'La razón social es requerida'),
    [OperacionLEPEmisorFields.CodOperacionLEPEmisorTipo]: z.number().min(1, 'El tipo de emisor es requerido')
});


export const schemaOperacionLEPInsert = z.object({
    [OperacionLEPFields.CodPais]: z.number(),
    [OperacionLEPFields.FechaAprobacion]: z.date(),
    [OperacionLEPFields.FechaVencimiento]: z.date(),
    [OperacionLEPFields.CodUnidadNegocio]: z.number(),
    [OperacionLEPFields.CodSectorComercial]: z.number(),
    [OperacionLEPFields.FechaAprobacionFinal]: z.date().optional().nullable(),
    [OperacionLEPFields.Emisores]: z.array(schemaOperacionLEPEmisorInsert).min(1, 'Debe agregar al menos un emisor')
});

export const schemaOperacionLEPEmisorView = z.object({
    id: z.number(),
    [OperacionLEPEmisorFields.RazonSocial]: z.string(),
    [OperacionLEPEmisorFields.CodOperacionLEPEmisorTipo]: z.number(),
    [OperacionLEPEmisorFields.DescOperacionLEPEmisorTipo]: z.string(),
    [OperacionLEPEmisorFields.PermiteEditar]: z.boolean(),
});

export const schemaOperacionLEPTitulo = z.object({
    [OperacionLEPTituloFields.Id]: z.number(),
    [OperacionLEPTituloFields.Descripcion]: z.string(),
    [OperacionLEPTituloFields.CodSistema]: z.number(),
    [OperacionLEPTituloFields.Titulo]: z.string(),
    [OperacionLEPTituloFields.IdEtapa]: z.number(),
    [OperacionLEPTituloFields.Activo]: z.boolean(),
    [OperacionLEPTituloFields.Inicial]: z.boolean()
});


export const schemaOperacionLEPUnidadNegocio = z
    .object({
        [OperacionLEPUnidadNegocioFields.Tipo]: z.number()
    })
    .merge(schemaEntityWithIdAndDescription)

export const schemaOperacionLEPTituloList = z.array(schemaOperacionLEPTitulo);
export const schemaOeracionLEPEmisorLimiteList = z.array(schemaOperacionLEPEmisorInsert);

export type OperacionLEPInsert = z.infer<typeof schemaOperacionLEPInsert>;
export type OperacionLEPEmisorInsert = z.infer<typeof schemaOperacionLEPEmisorInsert>;
export type OperacionLEPEmisorUpdate = z.infer<typeof schemaOperacionLEPEmisorUpdate>;
export type OperacionLEPEmisorView = z.infer<typeof schemaOperacionLEPEmisorView>;
export type OperacionLEPEmisorLimiteList = z.infer<typeof schemaOeracionLEPEmisorLimiteList>;
export type OperacionLEPTitulo = z.infer<typeof schemaOperacionLEPTitulo>;
export type OperacionLEPUnidadNegocio = z.infer<typeof schemaOperacionLEPUnidadNegocio>;





